<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Ventas</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="/">Home</a></li>
              <li class="breadcrumb-item active">Ventas</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <!-- Tarjetas de Acciones Rápidas -->
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <router-link to="/nuevaventa" class="btn btn-block info-box-icon bg-info elevation-1">
              <i class="fas fa-plus"></i>
            </router-link>
            <div class="info-box-content">
              <span class="info-box-text">Nueva</span>
              <span class="info-box-number">Cargar venta</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <a href="javascript:void(0)" id="btn-auditar" class="btn btn-block info-box-icon bg-warning elevation-1">
              <i class="fas fa-file-circle-question"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Auditar</span>
              <span class="info-box-number">Realizar Auditoria</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <a href="javascript:void(0)" id="btn-reporte" class="btn btn-block info-box-icon bg-success elevation-1">
              <i class="fas fa-print"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Guardar - Imprimir</span>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-12 col-md-8 mb-2 mb-md-0">
                  <h3 class="card-title text-wrap">
                    Listado de VENTAS
                    <span v-if="ventasPendientesContado > 0" class="badge badge-warning ml-md-2 mt-1 mt-md-0 d-block d-md-inline-block">
                      <i class="fas fa-exclamation-triangle mr-1"></i> {{ ventasPendientesContado }} ventas contado entregadas sin pago
                    </span>
                  </h3>
                </div>
                <div class="col-12 col-md-4 text-md-right">
                  <div class="dropdown d-inline-block w-100 w-md-auto">
                    <button ref="toggleFiltros" class="btn btn-info dropdown-toggle w-100" type="button" id="ddlFiltros"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-filter"></i> Filtros
                    </button>

                    <div class="dropdown-menu p-3 dropdown-menu-right shadow" aria-labelledby="ddlFiltros"
                      style="width: 100%; max-width: 320px;" @click.stop>
                      <div class="form-group">
                        <label class="form-label">Fecha desde</label>
                        <input type="date" v-model="filtros.fechaDesde" class="form-control" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Fecha hasta</label>
                        <input type="date" v-model="filtros.fechaHasta" class="form-control" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Estatus de pago</label>
                        <select v-model="filtros.statusPago" class="form-control">
                          <option value="">Todos</option>
                          <option value="pagada">Pagada</option>
                          <option value="pendiente">Pendiente</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label class="form-label">Estatus logístico</label>
                        <select v-model="filtros.statusLogistico" class="form-control">
                          <option value="">Todos</option>
                          <option value="pedido">Pedido</option>
                          <option value="asignado">Asignado</option>
                          <option value="entregado">Entregado</option>
                          <option value="finalizada">Finalizada</option>
                          <option value="anulado">Anulado</option>
                        </select>
                      </div>
                      <div class="d-flex justify-content-between mt-2">
                        <button class="btn btn-sm btn-outline-secondary" @click="limpiarFiltros">
                          Limpiar
                        </button>
                        <button class="btn btn-sm btn-primary" @click="aplicarFiltroFechasPersonalizadas">
                          Aplicar / Buscar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <!-- Botones Toggle de Rango de Tiempo Rápido -->
              <div class="row mb-3">
                <div class="col-12">
                  <div class="btn-group-toggle d-flex flex-column flex-sm-row flex-wrap gap-2" role="group">
                    <button type="button" class="btn btn-sm mb-1 mb-sm-0 flex-fill" :class="rangoTiempo === 7 ? 'btn-primary' : 'btn-outline-primary'" @click="cambiarRangoTiempo(7)">
                      Últimos 7 días
                    </button>
                    <button type="button" class="btn btn-sm mb-1 mb-sm-0 flex-fill" :class="rangoTiempo === 15 ? 'btn-primary' : 'btn-outline-primary'" @click="cambiarRangoTiempo(15)">
                      Últimos 15 días
                    </button>
                    <button type="button" class="btn btn-sm mb-1 mb-sm-0 flex-fill" :class="rangoTiempo === 30 ? 'btn-primary' : 'btn-outline-primary'" @click="cambiarRangoTiempo(30)">
                      Último Mes
                    </button>
                    <button type="button" class="btn btn-sm mb-1 mb-sm-0 flex-fill" :class="rangoTiempo === 90 ? 'btn-primary' : 'btn-outline-primary'" @click="cambiarRangoTiempo(90)">
                      Últimos 3 Meses
                    </button>
                  </div>
                </div>
              </div>

              <!-- Buscador -->
              <div class="row mb-3">
                <div class="col-12 col-md-6">
                  <input type="text" v-model="busqueda" class="form-control" placeholder="Buscar en los registros cargados..." />
                </div>
              </div>

              <!-- Tabla con comportamiento responsive estilo DataTables -->
              <div class="table-responsive">
                <table id="tablaVentas" class="table table-striped table-bordered align-middle">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 40px;"></th> <!-- Botón Expandir móvil -->
                      <th>Control</th>
                      <th class="d-none d-md-table-cell">Fecha</th>
                      <th>Cliente</th>
                      <th class="d-none d-lg-table-cell">Modalidad</th>
                      <th class="d-none d-sm-table-cell">Logística</th>
                      <th class="d-none d-xl-table-cell">Resumen Financiero</th>
                      <th class="d-none d-md-table-cell" style="width: 50px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="ventasPaginadas.length === 0">
                      <tr>
                        <td colspan="8" class="text-center text-muted py-4">No se encontraron registros en este periodo</td>
                      </tr>
                    </template>
                    
                    <template v-for="venta in ventasPaginadas" :key="venta.id">
                      <!-- Fila Principal -->
                      <tr :class="{
                        'table-warning': esVentaConAdvertencia(venta),
                        'table-danger': venta.status_logistico === 'anulado' || (venta.status_logistico === 'finalizada' && venta.status_pago === 'pendiente' && venta.tipo_pago === 'contado')
                      }">
                        <!-- Botón para expandir en móviles -->
                        <td class="text-center align-middle">
                          <button class="btn btn-sm btn-light d-md-none border" @click="toggleExpandir(venta.id)">
                            <i class="fas" :class="filasExpandidas.includes(venta.id) ? 'fa-minus text-danger' : 'fa-plus text-primary'"></i>
                          </button>
                        </td>
                        <td>
                          {{ venta.numcontrol }}
                          <i v-if="venta.tipo_pago === 'contado' && venta.status_logistico === 'finalizada' && venta.status_pago !== 'pagada'"
                            class="fas fa-exclamation-circle text-danger ml-1" title="Contado finalizado sin pago"></i>
                        </td>
                        <td class="d-none d-md-table-cell">{{ venta.fecha_venta }}</td>
                        <td>{{ venta.cliente ? venta.cliente.nombre : 'Sin Cliente' }}</td>
                        <td class="d-none d-lg-table-cell">
                          <span class="badge text-capitalize fw-normal px-2 py-1"
                            :class="venta.tipo_pago === 'contado' ? 'bg-light text-dark border' : 'bg-primary-subtle text-primary border border-primary-subtle'">
                            {{ venta.tipo_pago }}
                          </span>
                        </td>
                        <td class="d-none d-sm-table-cell">
                          <span class="badge rounded-pill fw-medium text-capitalize px-2 py-1" :class="[
                            venta.status_logistico === 'entregado' || venta.status_logistico === 'finalizada' ? 'bg-success-subtle text-success border border-success-subtle' :
                              venta.status_logistico === 'pedido' ? 'bg-info-subtle text-info-emphasis border border-info-subtle' :
                                venta.status_logistico === 'asignado' ? 'bg-warning-subtle text-warning-emphasis border border-warning-subtle' :
                                  venta.status_logistico === 'anulado' ? 'bg-danger-subtle text-danger border border-danger-subtle' : 'bg-light text-secondary border'
                          ]">
                            {{ venta.status_logistico }}
                          </span>
                        </td>
                        <td class="d-none d-xl-table-cell">
                          <div class="d-flex flex-column gap-1 style-financiero">
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-muted small">Monto:</span>
                              <strong class="text-dark">${{ (+venta.total).toFixed(2) }}</strong>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                              <span class="text-muted small">Abonado:</span>
                              <span class="text-success font-weight-bold">${{ (venta.total - venta.saldo).toFixed(2) }}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center border-top pt-1 mt-1">
                              <span class="text-muted small font-weight-bold">Pendiente:</span>
                              <span :class="venta.saldo > 0 ? 'text-danger font-weight-bold' : 'text-muted'">
                                ${{ (+venta.saldo).toFixed(2) }}
                              </span>
                            </div>
                          </div>
                        </td>
                        <!-- Botón de Acciones Desktop -->
                        <td class="d-none d-md-table-cell">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown"
                              aria-expanded="false">
                              <i class="fas fa-bars"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a href="javascript:void(0)" class="dropdown-item" @click="$router.push(`/ventas/${venta.id}`)">
                                <i class="fas fa-table mr-2"></i> Detalles
                              </a>
                              <a href="javascript:void(0)" class="dropdown-item" @click="abrirModalPago(venta)"
                                v-if="venta.status_pago !== 'pagada'">
                                <i class="fas fa-dollar-sign mr-2"></i> Cargar Pago
                              </a>
                              <a href="javascript:void(0)" class="dropdown-item" @click="abrirModalDespacho(venta)"
                                v-if="venta.status_logistico === 'pedido' || venta.status_logistico === 'asignado'">
                                <i class="fas" :class="venta.status_logistico === 'pedido' ? 'fa-truck' : 'fa-check'"></i>
                                {{ venta.status_logistico === 'pedido' ? ' Asignar' : ' Entregado' }}
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <!-- Subfila desplegable móvil (Incluye detalles y acciones) -->
                      <tr v-if="filasExpandidas.includes(venta.id)" class="bg-light d-md-none">
                        <td colspan="8" class="p-3">
                          <div class="card card-body mb-0 border shadow-sm">
                            <p class="mb-2"><strong>Fecha:</strong> {{ venta.fecha_venta }}</p>
                            <p class="mb-2">
                              <strong>Modalidad:</strong> 
                              <span class="badge text-capitalize ml-1" :class="venta.tipo_pago === 'contado' ? 'bg-light text-dark border' : 'bg-primary text-white'">
                                {{ venta.tipo_pago }}
                              </span>
                            </p>
                            <p class="mb-2">
                              <strong>Logística:</strong> 
                              <span class="badge text-capitalize ml-1" :class="venta.status_logistico === 'entregado' ? 'bg-success text-white' : 'bg-info text-white'">
                                {{ venta.status_logistico }}
                              </span>
                            </p>
                            <hr class="my-2">
                            <div class="style-financiero mb-3">
                              <div class="d-flex justify-content-between mb-1">
                                <span class="text-muted">Monto Total:</span>
                                <strong class="text-dark">${{ (+venta.total).toFixed(2) }}</strong>
                              </div>
                              <div class="d-flex justify-content-between mb-1">
                                <span class="text-muted">Abonado:</span>
                                <span class="text-success font-weight-bold">${{ (venta.total - venta.saldo).toFixed(2) }}</span>
                              </div>
                              <div class="d-flex justify-content-between border-top pt-1">
                                <span class="text-muted font-weight-bold">Pendiente:</span>
                                <span :class="venta.saldo > 0 ? 'text-danger font-weight-bold' : 'text-muted'">
                                  ${{ (+venta.saldo).toFixed(2) }}
                                </span>
                              </div>
                            </div>
                            
                            <!-- Botones de Acción integrados en móvil -->
                            <div class="d-flex flex-column gap-2">
                              <button type="button" class="btn btn-sm btn-outline-secondary w-100 mb-1" @click="$router.push(`/ventas/${venta.id}`)">
                                <i class="fas fa-table mr-2"></i> Ver Detalles
                              </button>
                              <button type="button" class="btn btn-sm btn-outline-success w-100 mb-1" @click="abrirModalPago(venta)" v-if="venta.status_pago !== 'pagada'">
                                <i class="fas fa-dollar-sign mr-2"></i> Cargar Pago
                              </button>
                              <button type="button" class="btn btn-sm btn-outline-info w-100" @click="abrirModalDespacho(venta)" v-if="venta.status_logistico === 'pedido' || venta.status_logistico === 'asignado'">
                                <i class="fas" :class="venta.status_logistico === 'pedido' ? 'fa-truck mr-2' : 'fa-check mr-2'"></i>
                                {{ venta.status_logistico === 'pedido' ? 'Asignar Despacho' : 'Confirmar Entrega' }}
                              </button>
                            </div>

                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>

              <!-- Paginación nativa adaptada -->
              <div class="row mt-3" v-if="totalPaginas > 1">
                <div class="col-12 d-flex justify-content-center">
                  <ul class="pagination pagination-sm flex-wrap">
                    <li class="paginate_button page-item" :class="{ disabled: paginaActual === 1 }">
                      <a href="#" class="page-link" @click.prevent="paginaActual--">Anterior</a>
                    </li>
                    <li v-for="pag in totalPaginas" :key="pag" class="paginate_button page-item" :class="{ active: paginaActual === pag }">
                      <a href="#" class="page-link" @click.prevent="paginaActual = pag">{{ pag }}</a>
                    </li>
                    <li class="paginate_button page-item" :class="{ disabled: paginaActual === totalPaginas }">
                      <a href="#" class="page-link" @click.prevent="paginaActual++">Siguiente</a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <pago-modal :pago="pagoSeleccionado" :venta="ventaParaPago" @guardar="onPagoGuardado" @cerrar="cerrarModalPago" />
    <asignar-despacho-modal ref="asignarDespachoModal" :despacho="despachoSeleccionado"
      :inicialCamion="camionInicialSeleccionado" @despachoAsignado="onDespachoAsignado"
      @entregaConfirmada="onEntregaConfirmada" />
  </section>
</template>

<script>
import { getCurrentInstance } from "vue";
import api from "@/services/api";
import PagoModal from "@/components/PagoModal.vue";
import AsignarDespachoModal from "@/components/AsignarDespachoModal.vue";
import { tutorial } from "@/plugins/tutorial";

export default {
  name: "Ventas",
  components: { PagoModal, AsignarDespachoModal },
  setup() {
    const { proxy } = getCurrentInstance();
    return { proxy };
  },
  data() {
    return {
      ventas: [],
      busqueda: "",
      paginaActual: 1,
      porPagina: 10,
      rangoTiempo: 7,
      filasExpandidas: [],
      filtros: {
        fechaDesde: "",
        fechaHasta: "",
        statusPago: "",
        statusLogistico: ""
      },
      pagoSeleccionado: {},
      ventaParaPago: null,
      despachoSeleccionado: null,
      camionInicialSeleccionado: null
    };
  },
  computed: {
    ventasPendientesContado() {
      return this.ventas.filter(v => v.tipo_pago === 'contado' && v.status_logistico === 'finalizada' && v.status_pago === 'pendiente').length;
    },
    ventasFiltradas() {
      return this.ventas.filter(v => {
        if (this.busqueda) {
          const texto = this.busqueda.toLowerCase();
          const matchNum = (v.numcontrol || "").toLowerCase().includes(texto);
          const matchCliente = (v.cliente?.nombre || "").toLowerCase().includes(texto);
          if (!matchNum && !matchCliente) return false;
        }

        if (this.filtros.statusPago && v.status_pago !== this.filtros.statusPago) return false;
        if (this.filtros.statusLogistico && v.status_logistico !== this.filtros.statusLogistico) return false;

        return true;
      });
    },
    totalPaginas() {
      return Math.ceil(this.ventasFiltradas.length / this.porPagina) || 1;
    },
    ventasPaginadas() {
      const inicio = (this.paginaActual - 1) * this.porPagina;
      return this.ventasFiltradas.slice(inicio, inicio + this.porPagina);
    }
  },
  watch: {
    busqueda() {
      this.paginaActual = 1;
    }
  },
  methods: {
    toggleExpandir(id) {
      const index = this.filasExpandidas.indexOf(id);
      if (index > -1) {
        this.filasExpandidas.splice(index, 1);
      } else {
        this.filasExpandidas.push(id);
      }
    },
    async obtenerVentas() {
      try {
        const params = {};

        if (this.filtros.fechaDesde && this.filtros.fechaHasta) {
          params.fecha_desde = this.filtros.fechaDesde;
          params.fecha_hasta = this.filtros.fechaHasta;
        } else {
          params.dias = this.rangoTiempo;
        }

        const respuesta = await api.get("/ventas", { params });
        this.ventas = respuesta.data || [];
        this.paginaActual = 1;
        this.filasExpandidas = [];
      } catch (error) {
        console.error("Error al obtener las ventas:", error);
      }
    },
    async cambiarRangoTiempo(dias) {
      this.rangoTiempo = dias;
      this.filtros.fechaDesde = "";
      this.filtros.fechaHasta = "";
      await this.obtenerVentas();
    },
    async aplicarFiltroFechasPersonalizadas() {
      if (this.filtros.fechaDesde && this.filtros.fechaHasta) {
        this.rangoTiempo = null;
        await this.obtenerVentas();
        this.cerrarDropdown();
      } else {
        this.proxy.$toast?.({ icon: 'warning', title: 'Debe seleccionar ambas fechas' }) || alert('Debe seleccionar ambas fechas');
      }
    },
    limpiarFiltros() {
      this.filtros = {
        fechaDesde: "",
        fechaHasta: "",
        statusPago: "",
        statusLogistico: ""
      };
      this.busqueda = "";
      this.rangoTiempo = 7;
      this.obtenerVentas();
      this.cerrarDropdown();
    },
    cerrarDropdown() {
      if (this.$refs.toggleFiltros) {
        $(this.$refs.toggleFiltros).dropdown('toggle');
      }
    },
    esVentaConAdvertencia(venta) {
      return (
        venta.tipo_pago !== 'credito' &&
        venta.status_logistico === 'entregado' &&
        venta.status_pago === 'pendiente'
      );
    },
    abrirModalPago(venta) {
      this.ventaParaPago = venta;
      const abonado = venta.pagoventas && venta.pagoventas.length > 0
        ? venta.pagoventas.reduce((acum, pv) => acum + parseFloat(pv.monto_aplicado || 0), 0)
        : 0;
      const saldo = parseFloat(venta.total) - abonado;

      this.pagoSeleccionado = {
        cliente_id: venta.cliente_id || (venta.cliente ? venta.cliente.id : ''),
        monto: saldo > 0 ? saldo.toFixed(2) : 0,
        fecha: new Date().toISOString().slice(0, 10),
        metodo: 'Efectivo'
      };

      $("#pagoModal").modal("show");
    },
    async onPagoGuardado(pago) {
      if (this.ventaParaPago && pago && pago.id) {
        try {
          const venta = this.ventaParaPago;
          const abonado = venta.pagoventas && venta.pagoventas.length > 0
            ? venta.pagoventas.reduce((acum, pv) => acum + parseFloat(pv.monto_aplicado || 0), 0)
            : 0;

          const saldoVenta = parseFloat(venta.total) - abonado;
          const montoAplicar = Math.min(parseFloat(pago.monto), saldoVenta);

          if (montoAplicar > 0) {
            await api.post('/pagoventas', {
              pago_id: pago.id,
              venta_id: venta.id,
              monto_aplicado: montoAplicar.toFixed(2)
            });
          }
        } catch (error) {
          console.error("Error al asignar el pago:", error);
        }
      }
      this.ventaParaPago = null;
      await this.obtenerVentas();
    },
    cerrarModalPago() {
      this.pagoSeleccionado = {};
      this.ventaParaPago = null;
    },
    abrirModalDespacho(venta) {
      if (!venta.despacho) {
        console.error("No se encontró el despacho asociado a la venta.");
        return;
      }
      this.despachoSeleccionado = { ...venta.despacho, venta };
      this.camionInicialSeleccionado = venta.despacho.almacen_id;
      this.$nextTick(() => {
        this.$refs.asignarDespachoModal.abrirModal();
      });
    },
    onDespachoAsignado() {
      this.proxy.$toast({ icon: 'success', title: 'Despacho asignado' });
      this.obtenerVentas();
    },
    onEntregaConfirmada() {
      this.proxy.$toast({ icon: 'success', title: 'Entrega confirmada' });
      this.obtenerVentas();
    },
    iniciarTutorial() {
      const steps = [
        { element: '.bg-info', title: 'Nueva Venta', text: 'Haz clic aquí para registrar una nueva venta.', position: 'bottom' },
        { element: '#btn-auditar', title: 'Auditoría', text: 'Accede al módulo de auditoría de ventas.', position: 'bottom' },
        { element: '#btn-reporte', title: 'Reportes', text: 'Genera e imprime reportes de ventas.', position: 'bottom' },
        { element: '.btn-group-toggle', title: 'Filtros Rápidos', text: 'Selecciona el período directo al servidor.', position: 'bottom' },
        { element: '#ddlFiltros', title: 'Filtros Avanzados', text: 'Filtra por fechas exactas o estados detallados.', position: 'left' },
        { element: '#tablaVentas', title: 'Diseño Colapsable', text: 'Usa el botón "+" en pantallas pequeñas para desplegar los detalles y los botones de acción.', position: 'top' }
      ];
      tutorial.start(steps);
    }
  },
  mounted() {
    this.obtenerVentas();
    tutorial.set(this.iniciarTutorial);
  },
  beforeUnmount() {
    tutorial.set(null);
  }
};
</script>

<style scoped>
.form-label {
  font-weight: 600;
}
@media (max-width: 576px) {
  .btn-group-toggle button {
    font-size: 0.75rem;
    padding: 0.35rem 0.5rem;
  }
}
</style>